/**
 * TargetingV3 — scaffold shell
 * Flag: targetingV3
 * API: api/v3/targeting (stub returning { message: 'TargetingV3 stub' })
 * NOTE: TargetingV2 (845 LOC) is the v3 starting point. This shell wraps it
 *       and progressively extracts the custom virtual grid into AG Grid.
 * TODO: Replace stub with real v3 targeting RTK Query endpoints
 */
import React from 'react';
import { useGetTargetingV3Query } from '../../api/targetingV3Api';

export default function TargetingV3() {
    const { data, isLoading, isError } = useGetTargetingV3Query();

    if (isLoading) return <p>Loading…</p>;
    if (isError)   return <p>Error loading Targeting.</p>;

    return (
        <main aria-label="Targeting v3 (scaffold)">
            <p>TargetingV3 scaffold — {JSON.stringify(data)}</p>
        </main>
    );
}
